<template>
  <VContainer fluid fill-height>
    <VFlex>
      <VLayout justify-center>
        <VFlex xs12 sm8 md5 xl3>
          <VCard primary class="pa-6">
            <slot name="top" />
            <VCardTitle class="justify-center">
              <slot name="title" />
            </VCardTitle>
            <VCardText>
              <slot name="body" />
            </VCardText>
            <VCardActions>
              <slot name="actions" />
            </VCardActions>
          </VCard>
        </VFlex>
      </VLayout>
      <VLayout justify-center>
        <VFlex xs12 sm8 md5 xl3 pt-4 class="card-under text-center">
          <slot name="under-card" />
        </VFlex>
      </VLayout>
      <VLayout justify-center class="purchases">
        <slot name="purchases" />
      </VLayout>
    </VFlex>
  </VContainer>
</template>

<script>
export default {
  name: 'SingleCard'
}
</script>
<style scoped>
.card-under {
  font-size: 20px;
}

.purchases {
    padding-bottom: 2rem
}
</style>
